import {Segment, Card, Image, Button, Label, Icon, Popup, Divider} from 'semantic-ui-react';

import {UsabilityOptions} from '../servicesDefinition';

import styles from './Services.module.scss';

function getProficiencyClassName(usability) {
  if (usability === UsabilityOptions.EASY) {
    return styles.Easy;
  } else if (usability === UsabilityOptions.MEDIUM) {
    return styles.Medium;
  } else if (usability === UsabilityOptions.ADVANCED) {
    return styles.Advanced;
  } else {
    return undefined;
  }
}

export default function Services({services}) {
  const totalServices = Object.keys(services).length;
  return Object.entries(services).map(([key, service], index) => {
    return (
      <div key={key} className={styles.Services}>
        <Segment className={styles.ServicesList}>
          <Card fluid className={styles.ServiceCard}>
            <Card.Content>
              <Card.Header>
                <Image className={styles.Icon} src={service.icon} />
                {service.title}
                <Button
                  className={styles.ActionButton}
                  href={service.url}
                  floated="right"
                  target="_blank"
                >
                  Try out
                </Button>
              </Card.Header>
              <Card.Description className={styles.Description}>
                {service.warning ? (
                  <>
                    <Popup
                      wide
                      position="top center"
                      content={service.warning}
                      trigger={<Icon color="red" name="warning sign" />}
                    />
                    <b>Provided for:</b> {service.recommended}
                  </>
                ) : (
                  <>
                    <b>Recommended for:</b> {service.recommended}
                  </>
                )}
              </Card.Description>
              <Card.Meta className={styles.TechnicalProficiency}>
                <b>Technical proficiency:</b>
                <Label circular className={getProficiencyClassName(service.usability)}>
                  {service.usability}
                </Label>
              </Card.Meta>
            </Card.Content>
            <Card.Content extra>
              <a
                target="_blank"
                href={service.infoUrl}
                className={styles.MoreInfo}
                rel="noreferrer"
              >
                More information
              </a>
            </Card.Content>
          </Card>
          {index + 1 !== totalServices && <Divider className={styles.Divider} />}
        </Segment>
      </div>
    );
  });
}
